export const Checkmate = {
	SUBHEADER1: 'Location List',
	HEADER_TEXT1: 'A location list will be assigned after the merchant activates Marketplace in the aggregator.',
	SUBHEADER2: 'Password',
	HEADER_TEXT2: 'A temporary password will be configured and sent to the email on file.'
};

export const Olo = {
	SUBHEADER1: 'Location List',
	HEADER_TEXT1: 'Select a Brand to view the associated locations.',
	SUBHEADER2: 'Password',
	HEADER_TEXT2: 'A temporary password will be configured and sent to the email on file.'
};

export const Otter = {
	SUBHEADER1: 'Location List',
	HEADER_TEXT1: 'A location list will be assigned after the merchant activates Marketplace in the aggregator.',
	SUBHEADER2: 'Password',
	HEADER_TEXT2: 'A temporary password will be configured and sent to the email on file.'
};

export const Stream = {
	SUBHEADER1: 'Location List',
	HEADER_TEXT1: 'Select a Brand to view the associated locations.',
	SUBHEADER2: 'Password',
	HEADER_TEXT2: 'A temporary password will be configured and sent to the email on file.'
};

export const BACK_BUTTON = 'Back';
export const CREATE_ACCOUNT = 'Create Account';
export const BRAND_NAME = 'Brand Name';
export const AGGREGATOR = 'Aggregator';
export const CREATE_A_MERCHANT_ACCOUNT = 'Create a Merchant Account';
export const MERCHANT_ACCOUNT = 'Merchant Account';
export const ORGANIZATION_NAME	 = 'Organization';
export const CHOOSE_AGGREGATOR = 'Choose an aggregator first to create an account.';
export const BRAND_NAME_POPULATE_BRAND = 'The Brand Name will automatically populate after merchant activation.';
export const BRAND_NAME_POPULATE_ORGANIZATION = 'The Organization will automatically populate after merchant activation.';

export const CHECKMATE = 'Checkmate';
export const OLO = 'Olo';
export const OTTER = 'Otter';
export const STREAM = 'Stream';
export const CONTINUE = 'Continue';
export const VIEW_LOCATIONS = 'View Locations';
export const ENTER_USERNAME = 'Please enter UserName';
export const ENTER_EMAIL = 'Please enter a valid email';

export const MERCHANT_ACCOUNT_DETAILS_CONTENT = [
		{
			id: 1,
			heading: 'What is this page and why is it important?',
			text : 'This page allows you to activate merchant accounts for the 7NOW marketplace. It ensures that merchants have the credentials and setup needed to integrate their store systems with the platform, facilitating their onboarding and future transactions.'
		},
		{
			id: 2,
			heading: 'Account Activation Process',
			text: [
				`Choose the aggregator / POS system.`,
				`Fill in the merchant's email and username.`,
				`The system automatically generates and emails a temporary password to the merchant. Then, instruct the merchant to use these credentials to log in, where they will be prompted to set a permanent password and complete their profile setup.`
			  ]
		},
		{
			id: 3,
			heading: 'Connecting the Aggregator or POS system to the Marketplace',
			text :`The merchant must connect their Aggregator / Point of Sale (POS) system with the marketplace using the credentials provided. This connection allows the merchant's product listings to be synced with the marketplace, enabling customers to view and purchase their offerings through the 7NOW app.`
		}
];

export const MERCHANT_CHECKMATE_DETAILS_CONTENT = [
		{
			id: 1,
			heading: 'What is this page and why is it important?',
			text : 'This page enables you to create accounts for merchants integrated via Checkmate-SMB, ensuring they have the credentials and setup needed to join the 7NOW marketplace, facilitating smooth onboarding and transactions.'
		},
		{
			id: 2,
			heading: 'Account Creation Process: Checkmate SMB',
			text: [
				'Aggregator: Pre-Set for merchants integrated via Checkmate-SMB',
				'Brand Name: Assigned post merchant activation (not available to select).',
				'Business Email: Enter the email to receive the password setup link.',
				'Username: Create a username for the merchant account.'
			]
		},
		{
			id: 3,
			heading: 'Connecting the POS to the Marketplace',
			text :'Merchants must connect their POS system with the marketplace using the provided credentials. This syncs their product listings with the marketplace, allowing customers to view and purchase items through the 7NOW app.'
		}
];

export const MERCHANT_OLO_DETAILS_CONTENT = [
	{
		id: 1,
		heading: 'What is this page and why is it important?',
		text : 'This page enables you to create accounts for merchants integrated via Olo.It ensures merchants have the credentials and setup needed to track their performance across the 7NOW marketplace platform, facilitating their growth.'
	},
	{
		id: 2,
		heading: 'Account Creation Process: Olo',
		text: [
			'Aggregator: For merchants integrated via Olo',
			'Brand Name: Select the brand from the dropdown',
			'Business Email: Enter the email to receive the password setup link.',
			'Username: Create a username for the merchant account.'
		]
	},
	{
		id: 3,
		heading: 'Connecting the POS to the Marketplace',
		text :'Merchants integrated via Olo do not need accounts for syncing their product listings with the marketplace. They can simply enable the 7NOW marketplace on their Olo tablets.'
	},
	{
		id: 4,
		heading: 'Why are accounts created',
		text :'These accounts are created for merchants so that they can log in to the merchant portal and track their performance.'
	}
];

export const MERCHANT_OTTER_DETAILS_CONTENT = [
	{
		id: 1,
		heading: 'What is this page and why is it important?',
		text : 'This page enables you to create accounts for merchants integrated via Otter. It ensures merchants have the credentials and setup needed to integrate their store systems with the 7NOW marketplace platform, facilitating their onboarding and future transactions.'
	},
	{
		id: 2,
		heading: 'Account Creation Process: Otter',
		text: [
			'Aggregator: Pre-set for merchants integrated via Otter',
			'Organization: Automatically assigned after merchant activation',
			'Business Email: Enter the email to receive the password setup link.',
			'Username: Create a username for the merchant account.'
		]
	},
	{
		id: 3,
		heading: 'Connecting the POS to the Marketplace',
		text :`The merchant must connect their Point of Sale (POS) system with the marketplace using the credentials provided. This connection allows the merchant's product listings to be synced with the marketplace, enabling customers to view and purchase their offerings through the 7NOW app.`
	}
];

export const MERCHANT_CREATEADMIN_DETAILS_CONTENT = [
	{
		id: 1,
		heading: 'Purpose of This Page:',
		text : 'This page lets you create new internal Admin accounts for the 7NOW Marketplace system. Admins have special access to manage users, oversee merchant accounts, and configure system settings.'
	},
	{
		id: 2,
		heading: 'How to Create an Admin Account',
		text: [
			'Business Email: Enter the email of the person who needs Admin access. Only @7-11.com emails are allowed',
			'Username: Choose a unique username for the Admin.',
			'Password: A temporary password will be sent to the email provided. The Admin will need to set a permanent password on their first login.'
		]
	},
	{
		id: 3,
		heading: 'Note:',
		text :'Only authorized personnel should be given Admin access due to the elevated permissions.'
	}
];

export const MERCHANT_STREAM_DETAILS_CONTENT = [
	{
		id: 1,
		heading: 'What is this page and why is it important?',
		text : 'This page allows you to create accounts for merchants integrated via Stream. It ensures merchants have the credentials and setup needed to integrate their store systems with the 7NOW marketplace platform, facilitating their onboarding and future transactions.'
	},
	{
		id: 2,
		heading: 'Account Creation Process: Stream',
		text: [
			'Aggregator: Pre-set for merchants integrated via Stream',
			'Brand Name: Select from a dropdown list of available brands',
			'Business Email: Enter the email to receive the password setup link.',
			'Username: Create a username for the merchant account.'
		]
	},
	{
		id: 3,
		heading: 'Connecting the POS to the Marketplace',
		text :`The merchant must connect their Point of Sale (POS) system with the marketplace using the credentials provided. This connection allows the merchant's product listings to be synced with the marketplace, enabling customers to view and purchase their offerings through the 7NOW app.`
	}
];
